<div class="registration-provider-translation">
  <h2 class="registration-provider-translation-title">{{ title  | translate }}</h2>
  <fgbcl-errors></fgbcl-errors>

  <ng-container *ngIf="accountsList && accountsList.length > 1">
    <div
      class="registration-provider-translation-card"
      *ngFor="let account of accountsList"
      [ngClass]="{ selected: externalRef === account.ExternalRefNumber }"
    >
      <div class="account-detail-field">
        <label>
          {{ 'fgbcl.registration.provider.translation.name.label' | translate }}
        </label>
        <div class="info-field">{{ account.FirstName }} {{ account.LastName }}</div>
      </div>
      <div class="account-detail-field">
        <label> {{ 'fgbcl.registration.provider.translation.account.label' | translate }}</label>
        <div class="info-field">{{ account.ExternalRefNumber }}</div>
      </div>
      <div class="account-detail-field">
        <label>{{ 'fgbcl.registration.provider.translation.status.label' | translate }}</label>
        <ng-container [ngSwitch]="account.Status">
          <div class="info-field">
            <div *ngSwitchCase="0">
              {{ 'fgbcl.registration.provider.translation.not.connected.label' | translate }}
            </div>
            <div *ngSwitchCase="1">
              {{ 'fgbcl.registration.provider.translation.connected.label' | translate }}
            </div>
            <div *ngSwitchCase="2">
              {{ 'fgbcl.registration.provider.translation.not.connected.label' | translate }}
            </div>
            <div *ngSwitchDefault>
              {{ 'fgbcl.registration.provider.translation.alreadyinuse.label' | translate }}
            </div>
          </div>
        </ng-container>
      </div>
      <div class="account-detail-field">
        <label>{{ 'fgbcl.registration.provider.translation.email.address.label' | translate }}</label>
        <div class="info-field">{{ account.EmailAddress }}</div>
      </div>
      
      <ng-container [ngSwitch]="account.Status">
        <ng-container *ngSwitchCase="0">
          <button (click)="submitStep(account.ExternalRefNumber)" class="btn create-account-btn">
            {{ 'fgbcl.registration.provider.translation.create.account.label' | translate }}
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <button class="btn login-account-btn">
            <a class="text-on-danger" [href]="account.RedirectUrl">
              {{ 'fgbcl.registration.provider.translation.log.in.label' | translate }}
            </a>
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <button (click)="submitStep(account.ExternalRefNumber)" class="btn create-account-btn">
            {{ 'fgbcl.registration.provider.translation.create.account.label' | translate }}
          </button>
        </ng-container>
        <ng-container *ngSwitchDefault>{{ 'fgbcl.registration.provider.translation.alreadyinuse.label' | translate }}</ng-container>
      </ng-container>
    </div>
  </ng-container>
  <div *ngIf="loading" class="w-100">
    <fgbcl-loading></fgbcl-loading>
  </div>

  <div class="action-wrapper">
    <button class="btn btn-previous-step" (click)="goToPreviousStep()">
        {{ 'registration.navigation.back.btn.text' | translate }}
    </button>
  </div>
</div>